import { AppUser } from "../types/users";

export const hasRole = (user: AppUser | null | undefined, roles: string[]) => {
  if (roles.includes("superadmin")) {
    return user && !user.sponsorId;
  }
  return user && user.role.some((role) => roles.includes(role));
};
